import React from "react";
import { FormGroup, Input, Label } from "reactstrap";
import styles from "./toggle.module.scss";

export interface InputSwitchProps {
  checked?: boolean;
  disabled?: boolean;
  id?: string;
  onChange?: (isChecked: boolean) => void;
  label?: string;
  icon?: string;
  className?: string;
  styling?: string;
}
export const Toggle: React.FC<InputSwitchProps> = ({
  disabled,
  checked = false,
  label,
  icon,
  styling,
  onChange,
}) => {
  return (
    <div className={`${styles.toggle} ${styling}`}>
      <FormGroup switch className={styles["switch-container"]}>
        <div className={styles.label}>
          {icon && <img src={icon} alt="icon" />}
          <Label
            className={
              disabled
                ? styles["switch-label-inactive"]
                : styles["switch-label"]
            }
          >
            {label}
          </Label>
        </div>
        <Input
          type="checkbox"
          role="switch"
          className={styles["switch-item"]}
          checked={checked}
          onChange={(e) => {
            onChange(e.target.checked);
          }}
          disabled={disabled}
        />
      </FormGroup>
    </div>
  );
};
